import { render, staticRenderFns } from "./TranslateCol.vue?vue&type=template&id=1d13ad15&scoped=true"
import script from "./TranslateCol.vue?vue&type=script&lang=js"
export * from "./TranslateCol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d13ad15",
  null
  
)

export default component.exports